import React from "react";
import { ActivityModule, Modules } from "../../../constants/Module";
import { ucFirst } from "../../../helpers/string_helper";
import { Action } from "../../../constants/Common";
import ArrowRightAltOutlinedIcon from "@mui/icons-material/ArrowRightAltOutlined";
import CreatorDetails from "./creatorDetails";
import { withTranslation } from "react-i18next";

const EditDeliverable = ({ item, t }) => {
    return (
        <React.Fragment>
            <div className="mx-2">
                {item?.module === ActivityModule.CHANGE_REQUEST_ITEM &&
                    <div>
                        <strong> {t('Edit')} {ucFirst(Modules.DELIVERABLE)} ({typeof item?.payload?.displayPayload?.name === 'object' ? item?.payload?.displayPayload?.name?.old : item?.payload?.displayPayload?.name}) </strong>
                         {item?.event === Action.CREATE ? t('was added to') : t('was removed from')} <strong>{t('change request')} ({item?.payload?.changeRequest?.uniqueChangeRequestId})</strong>
                        <CreatorDetails creator={item?.creator} date={item?.createdAt} />
                    </div>
                }
                {item?.module === ActivityModule.DELIVERABLE &&
                    <div>
                        <strong> {ucFirst(Modules.DELIVERABLE)} ({typeof item?.payload?.name === 'object' ? item?.payload?.name?.old : item?.payload?.name}) </strong>
                        {t('was updated from')} <strong>{t('change request')} ({item?.payload?.changeRequest?.uniqueChangeRequestId})</strong> {t('to')} <strong>{t('startup')} ({item?.project?.uniqueProjectId})</strong>
                        <CreatorDetails creator={item?.creator} date={item?.createdAt} />
                    </div>
                }
                {item?.event === Action.CREATE &&
                    <div>
                        {item?.payload?.payload?.name &&
                            item?.payload?.payload?.name?.old &&
                            item?.payload?.payload?.name?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('Name') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{item?.payload?.payload?.name?.old}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {item?.payload?.payload?.name?.new}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {item?.payload?.payload?.cost &&
                            item?.payload?.payload?.cost?.old &&
                            item?.payload?.payload?.cost?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('Cost') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{parseFloat(item?.payload?.payload?.cost?.old).toFixed(2)}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {parseFloat(item?.payload?.payload?.cost?.new).toFixed(2)}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {item?.payload?.payload?.weight >= 0 &&
                            item?.payload?.payload?.weight?.old >= 0 &&
                            item?.payload?.payload?.weight?.new >= 0 && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('Weight') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{item?.payload?.payload?.weight?.old}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {item?.payload?.payload?.weight?.new}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {item?.payload?.payload?.startDate &&
                            item?.payload?.payload?.startDate?.old &&
                            item?.payload?.payload?.startDate?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong>{ t('Start Date') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{item?.payload?.payload?.startDate?.old}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {item?.payload?.payload?.startDate?.new}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {item?.payload?.payload?.endDate &&
                            item?.payload?.payload?.endDate?.old &&
                            item?.payload?.payload?.endDate?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('End Date') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{item?.payload?.payload?.endDate?.old}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {item?.payload?.payload?.endDate?.new}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                    </div>
                }
                {item?.event === Action?.UPDATE &&
                    <div>
                        {item?.payload?.name &&
                            item?.payload?.name?.old &&
                            item?.payload?.name?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('Name') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{item?.payload?.name?.old}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {item?.payload?.name?.new}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {typeof item?.payload?.expectedOutput === 'object' && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('Expected Output') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{item?.payload?.expectedOutput?.old ?? 'N/A'}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {item?.payload?.expectedOutput?.new ?? 'N/A'}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {typeof item?.payload?.description === 'object' && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('Description') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{item?.payload?.description?.old ?? 'N/A'}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {item?.payload?.description?.new ?? 'N/A'}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {item?.payload?.cost &&
                            item?.payload?.cost?.old &&
                            item?.payload?.cost?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('Cost') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{parseFloat(item?.payload?.cost?.old).toFixed(2)}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {parseFloat(item?.payload?.cost?.new).toFixed(2)}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {typeof item?.payload?.weight === 'object' && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('Weight') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{item?.payload?.weight?.old}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {item?.payload?.weight?.new}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {item?.payload?.startDate &&
                            item?.payload?.startDate?.old &&
                            item?.payload?.startDate?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('Start Date') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{item?.payload?.startDate?.old}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {item?.payload?.startDate?.new}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {item?.payload?.endDate &&
                            item?.payload?.endDate?.old &&
                            item?.payload?.endDate?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('End Date') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{item?.payload?.endDate?.old}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {item?.payload?.endDate?.new}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                    </div>
                }
            </div>
        </React.Fragment>
    )
}
export default withTranslation()(EditDeliverable);
